import { NgModule } from '@angular/core';

import { AllAnalytics } from './all.analytics';
import { ANALYTICS } from './analytics';

@NgModule({
  providers: [AllAnalytics, { provide: ANALYTICS, useExisting: AllAnalytics }],
})
export class AnalyticsModule {}
